import React, { useCallback, useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useParams } from "react-router-dom";
import AdaptiveLoader from "../../Components/AdaptiveLoader/AdaptiveLoader";
import FilterSidebar from "../../Components/FilterSidebar/FilterSidebar";
import { Footer } from "../../Components/Footer/Footer";
import { Header } from "../../Components/Header/Header";
import { PageHeader } from "../../Components/PageHeader/PageHeader";
import { ProductCard } from "../../Components/ProductCard/ProductCard";
import SeoDefault from "../../Components/Seo/SeoDefault";
import {
  OrderIcon
} from "../../Components/siteIcons";
import { enviroment } from "../../enviroment";
import ApiService from "../../services/ApiService";
import styles from "./CategoryPage.module.css";

export const ShopCategoryPage = () => {
  const { verticalSlug } = useParams();

  const [ProductData, setProductData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [apiPayload, setApiPayload] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [filters, setFilters] = useState(null);
  const [prevFilterData, setPrevFilterData] = useState(null);

  const fetchProductsList = (data) => {
    ApiService.StoreCategoryProd(data)
      .then((res) => {
        if (res.message === "Fetch successfully.") {
          setProductData(res.payload_VerticalByProduct);
          setLoading(false);
          setApiPayload((prev) => ({ ...prev, page: 2 }));
        }
      })
      .catch((err) => { });
  };

  const LoadMoreProducts = () => {
    let pageCount = apiPayload?.page;
    pageCount = pageCount + 1;
    ApiService.StoreCategoryProd(apiPayload)
      .then((res) => {
        if (res.message === "Fetch successfully.") {
          let prevProdArr = [];
          prevProdArr = ProductData;
          let newProd = res.payload_VerticalByProduct;
          for (let i = 0; i < newProd.length; i++) {
            prevProdArr.push(newProd[i]);
          }
          let newProduct = [...prevProdArr];
          setProductData(newProduct);
          setLoading(false);
          setApiPayload((prev) => ({ ...prev, page: pageCount }));
        }
      })
      .catch((err) => { });
  };

  useEffect(() => {
    setLoading(true);
    const payload = {
      store_id: parseInt(enviroment.STORE_ID),
      vertical_slug: verticalSlug,
    };
    payload.page = 1;
    payload.result_per_page = 10;
    console.log(payload);
    setApiPayload(payload);
    fetchProductsList(payload);
  }, []);


  const getFilterData = useCallback(() => {
    let transformedFilters = null;
    if (filters !== null && filters !== undefined) {
      transformedFilters = {
        brands: filters?.brands || [],
        categories: filters?.categories || [],
        colors: filters?.colors || [],
        priceLow: filters?.priceRange?.min,
        priceHigh: filters?.priceRange?.max,
      };
    }
    const initialPayload = {
      vertical_slug: verticalSlug,
      store_id: Number.parseInt(process.env.REACT_APP_STORE_ID, 10),
    };
    if (transformedFilters) {
      initialPayload.filters = transformedFilters;
    }
    ApiService.StoreVerticalMeta(initialPayload)
      .then((res) => {
        if (res.message === "Fetch successfully.") {
          const filters = res?.payload_VerticalMeta?.filters;
          setFilterData({
            colors: filters?.colors,
            categories: filters?.categories,
            brands: filters?.brands,
            price_range_initial: filters?.price_range || {
              min: filters?.price_range?.min || "100",
              max: filters?.price_range?.max || "100000",
              ranges: filters?.price_range?.ranges ?? []
            },
            price_range: filters?.price_range || {
              min: filters?.price_range?.min || "100",
              max: filters?.price_range?.max || "100000",
              ranges: filters?.price_range?.ranges ?? []
            }
          });
        }
      })
      .catch((err) => { });
  }, [filters, verticalSlug]);

  useEffect(() => {
    if (filters !== null && filters !== undefined) {
      if (JSON.stringify(filters) === JSON.stringify(prevFilterData)) {
        return;
      }
      const transformedFilters = {
        brands: filters?.brands || [],
        categories: filters?.categories || [],
        colors: filters?.colors || [],
        priceLow: filters?.priceRange?.min,
        priceHigh: filters?.priceRange?.max,
      };
      const payload = {
        store_id: parseInt(enviroment.STORE_ID),
        vertical_slug: verticalSlug,
        filters: transformedFilters
      };
      fetchProductsList(payload)
      getFilterData(payload)
      setPrevFilterData(filters);
    }
  }, [filters, getFilterData, prevFilterData, verticalSlug]);

  useEffect(() => {
    getFilterData()
  }, [getFilterData])


  return (
    <React.Fragment>
      <SeoDefault
        keywords={`${verticalSlug}, ${enviroment.BUSINESS_NAME}, Electronics, Appliances, buy online`}
        canonicalUrl={`${process.env.REACT_APP_URL}/store/${verticalSlug}`}
        pageType="website"
        breadcrumbItems={[
          { name: "Home", url: `${process.env.REACT_APP_URL}/` },
          { name: verticalSlug, url: `${process.env.REACT_APP_URL}/store/${verticalSlug}` },
        ]}
      />
      {/* Mobile Structure */}
      <div className="hideInDesktop">
        <PageHeader title="Explore Category" />
      </div>


      {/* Desktop Structure */}
      <div className="hideInMobile">
        <Header />
      </div>

      <div
        className={"mt-4 col-12 d-inline-flex flex-column mt-4"}
      >
        <div className=" container p-0" style={{
        }}>
          {/* {locationState?.state?.banner !== "" &&
            locationState?.state?.banner !== null &&
            locationState?.state?.banner !== undefined && (
              <div
                className={`${styles.ageBannerRow} col-12 d-inline-flex mb-4`}
              >
                <img
                  src={locationState.state.banner[0]?.image}
                  alt="Banner"
                  className="col-12 d-inline-block"
                />
              </div>
            )} */}
          {loading && <AdaptiveLoader />}
          {loading === false && (
            <div
              className={`d-inline-flex flex-column col-12 mb-3`}
              id="scrollableDiv"
            >
              <div style={{
                position: "relative",
                height: "100%",
                maxWidth: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}>
                <FilterSidebar
                  filterData={filterData}
                  filters={filters}
                  setFilters={setFilters}
                  isMobile={false}
                  filterType={'vertical'}
                />
                <div
                  className={`${styles.productContainer
                    } flex-shrink-1 d-inline-flex flex-wrap w-100`}>
                  {ProductData?.length > 0 ? (
                    <InfiniteScroll
                      className="d-inline-flex col-12 flex-wrap"
                      dataLength={ProductData.length}
                      next={LoadMoreProducts}
                      hasMore={true}
                    >
                      {ProductData?.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            {item.name !== "" && (
                              <div
                                className={`${styles.productCardBox} px-2 flex-shrink-0 mb-3`}
                                key={index}
                                role="button"
                              >
                                <ProductCard item={item} index={index} />
                              </div>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </InfiniteScroll>
                  ) : (
                    <React.Fragment>
                      <div
                        className={`${styles.emptyProduct} d-inline-flex align-items-center justify-content-center flex-column gap-4 p-4 col-12`}
                      >
                        <OrderIcon color="#888" />
                        <label
                          className={`${styles.emptyProductText} col-12 text-center`}
                        >
                          No Products Found
                        </label>
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
};